import React, { useEffect, useState, useRef, createContext } from "react";
import { Col, Row } from "react-bootstrap";
import "../Spot/Spot.css";

import axios from "axios";
import SockJS from "sockjs-client";
import Stomp from "stompjs";
import FlipNumbers from "react-flip-numbers";

import { useLocation } from "react-router-dom";
import OptionLeftTable from "./OptionLeftTable";
import OptionTVChart from "./OptionTVChart";
import OptionDepthChart from "./OptionDepthChart";
import OptionBuyAndSell from "./OptionBuySell";
import OptionRightTable from "./OptionRightTable";
import OptionBottomTable from "./OptionBottomTable";
import { checkInternetConnection } from "../../CoreDataService";
import { Box, Typography, alpha } from "@mui/material";
import ShowChartOutlinedIcon from "@mui/icons-material/ShowChartOutlined";
import BarChartOutlinedIcon from "@mui/icons-material/BarChartOutlined";
import TrendingUpOutlinedIcon from "@mui/icons-material/TrendingUpOutlined";
import TrendingDownOutlinedIcon from "@mui/icons-material/TrendingDownOutlined";
import { useSelector } from "react-redux";

export const OptionDataContenxt = createContext();

const OptionChartDashboard = () => {
  const location = useLocation();
  const theme = localStorage.getItem("theme");
  const { btncolor } = useSelector((state) => state);
  const [isConnected, setIsConnected] = useState(true);
  const paramBaseCurrency = location.state;
  const [activeButton, setActiveButton] = useState("Price");
  const [data, setData] = useState({});
  const [title, setTitle] = useState("angulartitle");
  const [chartData, setChartData] = useState(null);
  const [ltp, setLtp] = useState(null);
  const [markPrice, setMarkPrice] = useState(null);
  const [indexPrice, setIndexPrice] = useState(null);
  const [rocData, setRocData] = useState(0);
  const [volumnData, setVolumnData] = useState(0);
  const [lowPrice, setLowPrice] = useState(0);
  const [highPrice, setHighPrice] = useState(0);
  const [action, setAction] = useState("");
  const [isNegative, setIsNegative] = useState(false);
  const [isRocReact, setIsRocReact] = useState(false);
  const [themeColor, setThemeColor] = useState("light");
  const [finalBiddata, setFinalBiddata] = useState([]);
  const [finalAskdata, setFinalAskdata] = useState([]);
  const [lastAskItem, setLastAskItem] = useState(null);
  const [firstBidItem, setFirstBidItem] = useState(null);
  const [derivativeAssets, setDerivativeAssets] = useState();
  const [updateBalance, setUpdateBalance] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currencycode, setCurrencycode] = useState(
    localStorage.getItem("buying_crypto_asset_options") || "BTC"
  );
  const [basecurrency, setBasecurrency] = useState("USDT");

  const [assetpair, setAssetPair] = useState(
    paramBaseCurrency || localStorage.getItem("selected_options_asset_pair") || ""
  );
  const [assetPairName, setAssetPairName] = useState(
    localStorage.getItem("selected_options_asset_pair_name") || ""
  );
  const [sellData, setSellData] = useState("");
  const [buyData, setBuyData] = useState("");

  const [message, setMessage] = useState(null); // Store received messages
  const [connected, setConnected] = useState(false); // Connection status
  const stompClientRef = useRef(null); // Store the Stomp client instance
  const [buyingAsset, setBuyingAsset] = useState(
    localStorage.getItem("buying_crypto_asset_options") || "BTC"
  );
  const [sellingAsset, setSellingAsset] = useState(
    localStorage.getItem("selling_crypto_asset_options") || "USDT"
  );
  const [limitTrede, setLimitTrede] = useState(false);

  const allProps = {
    chartData,
    setFinalBiddata,
    setFinalAskdata,
    setCurrencycode,
    setBasecurrency,
    setAssetPair,
    currencycode,
    basecurrency,
    lowPrice,
    highPrice,
    assetpair,
    setAssetPairName,
    setDerivativeAssets,
    paramBaseCurrency,
    finalBiddata,
    finalAskdata,
    lastAskItem,
    firstBidItem,
    setLastAskItem,
    setFirstBidItem,
    ltp,
    assetPairName,
    derivativeAssets,
    setUpdateBalance,
    updateBalance,
    setRefresh,
    refresh,
    setSellData,
    setBuyData,
    sellData,
    buyData,
    setLimitTrede,
    limitTrede,
  };

  const [reqNo, setReqNo] = useState(Math.floor(Math.random() * 1000) + 1);
  const webSocketEndPoint =
    "https://options-socket.paybito.com/OptionChartStream/ws";
  const topic = "/user/topic/stream/tradingView";

  const changeMessage = (msg) => {
    setMessage(msg);
  };

  const _connect = () => {
    if (localStorage.getItem("access_token")) {
      const socket = new SockJS(webSocketEndPoint);
      stompClientRef.current = Stomp.over(socket);
      stompClientRef.current.debug = null; // Disable debug logging

      stompClientRef.current.connect(
        {},
        (frame) => {
          if (stompClientRef.current && stompClientRef.current.connected) {
            stompClientRef.current.subscribe(topic, (sdkEvent) => {
              onMessageReceived(sdkEvent);
            });
            subscribe(); // Ensure this doesn't rely on an unready connection
            setConnected(true);
          } else {
            console.error("STOMP connection not ready yet.");
          }
        },
        errorCallBack
      );
    } else {
      console.log("Access token is not available");
    }
  };

  const _disconnect = () => {
    // if (stompClientRef.current !== null) {
    //   stompClientRef.current.disconnect();
    //   setConnected(false);
    // }
  };

  const errorCallBack = (error) => {
    if (localStorage.getItem("access_token") !== null) {
      setTimeout(() => {
        _connect();
      }, 5000);
    }
  };

  const _send = (message) => {
    if (!stompClientRef.current || !stompClientRef.current.connected) {
      console.error("WebSocket is not connected yet.");
      return;
    }

    const sendMessage = {
      method: "SUBSCRIBE",
      params: [
        `${buyingAsset.toLowerCase()}/${sellingAsset.toLowerCase()}@ticker`,
        `${buyingAsset.toLowerCase()}${sellingAsset.toLowerCase()}@depth`,
        `${buyingAsset.toLowerCase()}${sellingAsset.toLowerCase()}@trade`,
      ],
      id: reqNo,
    };

    stompClientRef.current.send(
      "/app/sendRequest",
      {},
      JSON.stringify(sendMessage)
    );
  };

  const onMessageReceived = (message) => {
    const parsedMessage = JSON.parse(message.body);
    changeMessage(parsedMessage); // Store message
    const data = parsedMessage.tR;

    if (data !== null) {
      setChartData(data);
      // setMarkPrice(parseFloat(data?.markPrice)?.toFixed(2));
      // setIndexPrice(parseFloat(data?.indexPrice)?.toFixed(2));
      setLowPrice(parseFloat(data?.lowPrice)?.toFixed(2));
      setHighPrice(parseFloat(data?.highPrice)?.toFixed(2));
      setAction(data?.action);
      setRocData(parseFloat(data?.roc).toFixed(2));
      setVolumnData(parseFloat(data?.volume).toFixed(2));
      setIsRocReact(data?.roc > 0);
      setIsNegative(data?.roc < 0);
      setTitle(
        `${data?.ltp} | ${buyingAsset}${sellingAsset} | ${data?.exchange}`
      );
    }
  };

  const subscribe = () => {
    if (buyingAsset && sellingAsset) {
      const req = {
        method: "SUBSCRIBE",
        params: [
          `${buyingAsset.toLowerCase()}/${sellingAsset.toLowerCase()}@ticker`,
          `${buyingAsset.toLowerCase()}${sellingAsset.toLowerCase()}@depth`,
          `${buyingAsset.toLowerCase()}${sellingAsset.toLowerCase()}@trade`,
        ],
        id: reqNo,
      };
      setTimeout(() => {
        _send(req);
      }, 10000);
      localStorage.setItem("isUnsubscribeOccured", "false");
    }
  };

  const unsubscribe = () => {
    try {
      if (
        localStorage.getItem("lastBuyingAsset") &&
        localStorage.getItem("lastSellingAsset")
      ) {
        const lastBuyingAsset = localStorage
          .getItem("lastBuyingAsset")
          .toLowerCase();
        const lastSellingAsset = localStorage
          .getItem("lastSellingAsset")
          .toLowerCase();
        const req = {
          method: "UNSUBSCRIBE",
          params: [
            `${lastBuyingAsset}/${lastSellingAsset}@ticker`,
            `${lastBuyingAsset}${lastSellingAsset}@depth`,
            `${lastBuyingAsset}${lastSellingAsset}@trade`,
          ],
          id: reqNo,
        };
        setTimeout(() => {
          _send(req);
        }, 10000);
        localStorage.setItem("isUnsubscribeOccured", "true");
      }
    } catch (error) {
      window.location.reload();
    }
  };

  useEffect(() => {
    const fetchTickerData = () => {
      axios
        .get(
          `https://options-socket.paybito.com/oSocketStream/api/get24hTicker?assetPair=${assetpair}`,
          {
            headers: {
              "Content-Type": "application/json",
              authorization: `BEARER ${localStorage.getItem("access_token")}`,
            },
          }
        )
        .then((response) => {
          const result = response.data;
          if (result && result.length) {
            const data = result[0];
            setChartData(data);
            setMarkPrice(parseFloat(data.markPrice).toFixed(2));
            setIndexPrice(parseFloat(data.indexPrice).toFixed(2));
            setLtp(data?.ltp);
            setLowPrice(parseFloat(data.lowPrice).toFixed(2));
            setHighPrice(parseFloat(data.highPrice).toFixed(2));
            setAction(data.action);
            setRocData(parseFloat(data.roc).toFixed(2));
            setVolumnData(parseFloat(data.volume).toFixed(2));
            setIsRocReact(data.roc > 0);
            setIsNegative(data.roc < 0);
            setTitle(
              `${data?.ltpdata} | BTCUSDT Perpetual | ${data?.exchange}`
            );
          }

          _connect();
        })
        .catch((error) => {
          console.error("Error fetching 24h ticker data manually:", error);
        });
    };

    fetchTickerData();

    return () => {
      _disconnect();
    };
  }, [assetpair, limitTrede]);

  useEffect(() => {
    // Call the function and get the cleanup function
    const cleanup = checkInternetConnection(setIsConnected);

    // Cleanup listeners when component unmounts
    return () => cleanup();
  }, []);

  const handleButtonClick = (button) => {
    setActiveButton(button);
  };

  return (
    <OptionDataContenxt.Provider value={allProps}>
      <Box sx={pageWrapper}>

        {/* ── Ticker Strip ── */}
        <Box sx={tickerStrip}>

          {/* Left — Pair badge */}
          <Box sx={tickerPairBadge}>
            <Box sx={tickerPairIconWrap}>
              <ShowChartOutlinedIcon sx={{ fontSize: 15, color: "#fff" }} />
            </Box>
            <Box>
              <Typography sx={tickerPairText}>
                {assetpair || assetPairName}
              </Typography>
              <Typography sx={tickerPairSub}>Options</Typography>
            </Box>
          </Box>

          {/* Center — Stats */}
          <Box sx={tickerStatsCenter}>
            <Box sx={tickerDivider} />

            {/* Last Price */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>LAST PRICE</Typography>
              <Typography sx={{ ...tickerStatValue, color: isNegative ? "#F5475D" : "#21CB80", fontWeight: 800, fontSize: "1rem" }}>
                <FlipNumbers
                  height={14}
                  width={9}
                  play
                  duration={2}
                  numbers={Number(chartData?.ltp).toLocaleString(undefined, {
                    minimumFractionDigits: 6,
                    maximumFractionDigits: 6,
                  })}
                />
              </Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* MTM */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>MTM</Typography>
              <Typography sx={tickerStatValue}>{markPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* Index */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>INDEX</Typography>
              <Typography sx={tickerStatValue}>{indexPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Change */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H CHANGE</Typography>
              <Box sx={{ display: "flex", alignItems: "center", gap: "3px" }}>
                {isNegative
                  ? <TrendingDownOutlinedIcon sx={{ fontSize: 13, color: "#F5475D" }} />
                  : <TrendingUpOutlinedIcon sx={{ fontSize: 13, color: "#21CB80" }} />}
                <Typography sx={{ ...tickerStatValue, color: isNegative ? "#F5475D" : "#21CB80" }}>
                  {rocData}%
                </Typography>
              </Box>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Volume */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H VOL</Typography>
              <Typography sx={tickerStatValue}>{volumnData}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H High */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H HIGH</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#21CB80" }}>{highPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />

            {/* 24H Low */}
            <Box sx={tickerStat}>
              <Typography sx={tickerStatLabel}>24H LOW</Typography>
              <Typography sx={{ ...tickerStatValue, color: "#F5475D" }}>{lowPrice}</Typography>
            </Box>

            <Box sx={tickerDivider} />
          </Box>

          {/* Right — Connection status */}
          <Box sx={tickerConnectionWrap}>
            <Box sx={tickerConnectionPill}>
              <Box
                sx={{
                  width: 6, height: 6, borderRadius: "50%", flexShrink: 0,
                  backgroundColor: isConnected ? "#21CB80" : "#F5475D",
                  boxShadow: isConnected ? "0 0 5px #21CB80" : "0 0 5px #F5475D",
                  animation: isConnected ? "tickerPulse 2s ease-in-out infinite" : "none",
                }}
              />
              <Typography sx={{ fontSize: "0.7rem", fontWeight: 700, color: isConnected ? "#21CB80" : "#F5475D", letterSpacing: "0.06em" }}>
                {isConnected ? "LIVE" : "OFFLINE"}
              </Typography>
            </Box>
          </Box>
        </Box>

        {/* ── Main Trading Layout ── */}
        <Box sx={tradingLayout}>
          <Row className="LetfTable" style={{ margin: 0, flex: 1 }}>

            {/* Left Order Book */}
            <Col xs={12} sm={12} md={2} className="mb-1 position-relative p-0 orderbooktable">
              <Box sx={panelCard}>
                <OptionLeftTable />
              </Box>
            </Col>

            {/* Chart + Buy/Sell */}
            <Col xs={12} sm={12} md={8} className="mb-1 px-1 spotchart">
              <Box sx={{ ...panelCard, height: "auto" }}>
                {/* Chart toggle buttons */}
                <Box sx={chartToggleWrap}>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor: activeButton === "Price"
                        ? alpha(btncolor || "#1976d2", 0.15)
                        : "transparent",
                      color: activeButton === "Price"
                        ? btncolor || "#1976d2"
                        : "var(--text-color)",
                      borderColor: activeButton === "Price"
                        ? alpha(btncolor || "#1976d2", 0.4)
                        : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Price" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Price")}
                  >
                    <ShowChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Price
                  </Box>
                  <Box
                    sx={{
                      ...chartToggleBtn,
                      backgroundColor: activeButton === "Depth"
                        ? alpha(btncolor || "#1976d2", 0.15)
                        : "transparent",
                      color: activeButton === "Depth"
                        ? btncolor || "#1976d2"
                        : "var(--text-color)",
                      borderColor: activeButton === "Depth"
                        ? alpha(btncolor || "#1976d2", 0.4)
                        : "rgba(125,125,125,0.2)",
                      fontWeight: activeButton === "Depth" ? 700 : 500,
                    }}
                    onClick={() => handleButtonClick("Depth")}
                  >
                    <BarChartOutlinedIcon sx={{ fontSize: 14 }} />
                    Depth
                  </Box>
                </Box>

                {activeButton === "Price" ? <OptionTVChart /> : <OptionDepthChart />}
              </Box>

              <Box sx={{ ...panelCard, mt: "6px", height: "auto" }}>
                <OptionBuyAndSell />
              </Box>
            </Col>

            {/* Right Order Book */}
            <Col xs={12} sm={12} md={2} className="mb-1 p-0 orderbooktable">
              <Box sx={panelCard}>
                <OptionRightTable />
              </Box>
            </Col>

            {/* Bottom Table */}
            <Col xs={12} md={12} className="mb-4 p-0">
              <Box sx={{ ...panelCard, mt: "6px" }}>
                <OptionBottomTable />
              </Box>
            </Col>

          </Row>
        </Box>

      </Box>
    </OptionDataContenxt.Provider>
  );
};

// ── Styles ────────────────────────────────────────────────────────────────────

const pageWrapper = {
  backgroundColor: "var(--body-color)",
  color: "var(--text-color)",
  minHeight: "100vh",
  zoom: "90%",
};

// Ticker strip
const tickerStrip = {
  display: "flex",
  alignItems: "center",
  flexWrap: "nowrap",
  px: { xs: 2, md: "14px" },
  py: "10px",
  mb: "6px",
  backgroundColor: "var(--body-color-less)",
  borderBottom: "1px solid rgba(125,125,125,0.18)",
  position: "relative",
};

// Center stats group — takes remaining space, centers content
const tickerStatsCenter = {
  flex: 1,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  gap: 0,
  overflow: "hidden",
};

const tickerPairBadge = {
  display: "flex",
  alignItems: "center",
  gap: "10px",
  pr: { md: "20px" },
  mr: { md: "4px" },
};

const tickerPairIconWrap = {
  width: 32,
  height: 32,
  borderRadius: "8px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  backgroundColor: "rgba(125,125,125,0.18)",
  flexShrink: 0,
};

const tickerPairText = {
  fontSize: { xs: "0.95rem", md: "1rem" },
  fontWeight: 800,
  color: "var(--text-color)",
  letterSpacing: "0.02em",
  lineHeight: 1.2,
};

const tickerPairSub = {
  fontSize: "0.6rem",
  fontWeight: 600,
  color: "var(--text-color)",
  opacity: 0.4,
  textTransform: "uppercase",
  letterSpacing: "0.08em",
  lineHeight: 1,
  mt: "2px",
};

const tickerDivider = {
  width: "1px",
  height: 30,
  backgroundColor: "rgba(125,125,125,0.2)",
  mx: { xs: 0, md: "16px" },
  display: { xs: "none", md: "block" },
  flexShrink: 0,
};

const tickerStat = {
  display: "flex",
  flexDirection: "column",
  gap: "3px",
  pr: { md: "16px" },
};

const tickerStatLabel = {
  fontSize: "0.58rem",
  fontWeight: 700,
  color: "var(--text-color)",
  opacity: 0.45,
  textTransform: "uppercase",
  letterSpacing: "0.07em",
  lineHeight: 1,
};

const tickerStatValue = {
  fontSize: "0.82rem",
  fontWeight: 700,
  color: "var(--text-color)",
  lineHeight: 1.2,
  display: "flex",
  alignItems: "center",
};

const tickerConnectionWrap = {
  display: "flex",
  alignItems: "center",
  flexShrink: 0,
};

const tickerConnectionPill = {
  display: "flex",
  alignItems: "center",
  gap: "5px",
  px: "10px",
  py: "4px",
  borderRadius: "20px",
  border: "1px solid rgba(125,125,125,0.2)",
  backgroundColor: "rgba(125,125,125,0.08)",
};

// Trading layout
const tradingLayout = {
  px: "6px",
  pb: "50px",
};

// Panel / card wrapper
const panelCard = {
  backgroundColor: "var(--body-color-less)",
  border: "1px solid rgba(125,125,125,0.13)",
  borderRadius: "10px",
  overflow: "hidden",
  height: "100%",
};

// Chart toggle bar
const chartToggleWrap = {
  display: "flex",
  alignItems: "center",
  gap: "6px",
  px: "8px",
  py: "6px",
  borderBottom: "1px solid rgba(125,125,125,0.13)",
  backgroundColor: "var(--body-color-less2)",
};

const chartToggleBtn = {
  display: "inline-flex",
  alignItems: "center",
  gap: "5px",
  px: "12px",
  py: "5px",
  borderRadius: "8px",
  border: "1px solid",
  fontSize: "0.75rem",
  cursor: "pointer",
  userSelect: "none",
  transition: "all 0.15s ease",
  letterSpacing: "0.01em",
};

export default OptionChartDashboard;
